/** @format */
import styled from 'styled-components';

import { theme } from '@toucan/config/theme';

import { ProductComparisonItemHeader } from '../../product-comparison-item.styles';

export const ProductComparisonItemOutOfStockHeader = styled(
    ProductComparisonItemHeader
)`
    ${theme.typography.body_small}
    grid-template-columns: 1fr;
    justify-items: center;

    .product-comparison-item-out-of-stock-message {
        text-align: center;
        margin-bottom: var(--layout-spacing-24);

        p {
            margin-bottom: 0;
        }
    }
`;
